/** Creare clip (App-CreareClip.dc.html) — cele 3 uși + banda „aceiași pași simpli". */
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export function CreateClipPage() {
  const navigate = useNavigate();
  useEffect(() => {
    document.title = 'Creează clip — Reclame Video';
  }, []);

  const doors = [
    {
      key: 'sablon',
      testid: 'door-sablon',
      badge: 'Cel mai rapid',
      title: 'Alege un șablon',
      body: 'Formate testate pe nișa ta, cu exemple video. Cel mai rapid drum — alegi și personalizezi.',
      cta: 'Vezi șabloanele →',
      onClick: () => navigate('/wizard'),
    },
    {
      key: 'interviu',
      testid: 'door-interviu',
      badge: 'Ghidat de AI',
      title: 'Descrie cu AI',
      body: 'Agentul te întreabă pe rând ce vinzi și cui, apoi îți propune șablonul și scenariul. Fără pânză goală.',
      cta: 'Pornește interviul →',
      onClick: () => navigate('/interviu'),
    },
    {
      key: 'produs',
      testid: 'door-produs',
      badge: 'De la produs',
      title: 'Pornește de la produs',
      body: 'Alegi un produs din biblioteca ta — AI-ul îi știe deja prețul, beneficiile și pozele.',
      cta: 'Alege produsul →',
      onClick: () => navigate('/wizard?door=produs'),
    },
  ];

  return (
    <div>
      <p style={{ margin: 0, fontSize: 12.5, fontWeight: 800, letterSpacing: '.12em', textTransform: 'uppercase', color: 'var(--accent-text)' }}>
        Clip nou
      </p>
      <h1 className="bricolage" style={{ margin: '6px 0 0', fontWeight: 800, fontSize: 'clamp(26px,3.4vw,34px)' }}>
        Ce creăm azi?
      </h1>
      <p style={{ margin: '8px 0 0', fontSize: 14.5, color: 'var(--muted)', maxWidth: '60ch' }}>
        Alege drumul care ți se potrivește — toate trei duc la același rezultat: un clip gata de postat.
      </p>

      <div className="pill" style={{ marginTop: 16, background: 'var(--ok-soft)', color: 'var(--ok)' }}>
        <span aria-hidden="true">✓</span>
        Nu consumi nimic din sold până nu aprobi generarea videoclipului — costul îl vezi mereu înainte.
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(260px,1fr))', gap: 16, marginTop: 24 }}>
        {doors.map((d) => (
          <button
            key={d.key}
            data-testid={d.testid}
            onClick={d.onClick}
            className="card"
            style={{ textAlign: 'left', padding: 22, display: 'flex', flexDirection: 'column', gap: 12, alignItems: 'stretch', transition: 'transform .18s, box-shadow .18s' }}
            onMouseEnter={(e) => (e.currentTarget.style.transform = 'translateY(-3px)')}
            onMouseLeave={(e) => (e.currentTarget.style.transform = 'translateY(0)')}
          >
            <span className="pill" style={{ alignSelf: 'flex-start', background: 'var(--accent-soft)', color: 'var(--accent-text)' }}>
              {d.badge}
            </span>
            <h2 className="bricolage" style={{ fontWeight: 800, fontSize: 21 }}>{d.title}</h2>
            <p style={{ margin: 0, fontSize: 13.5, color: 'var(--muted)', lineHeight: 1.6, flex: 1 }}>{d.body}</p>
            <span style={{ fontWeight: 800, fontSize: 14, color: 'var(--accent-text)' }}>{d.cta}</span>
          </button>
        ))}
      </div>

      <div className="card" style={{ marginTop: 24, padding: '18px 20px', display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap' }}>
        <span style={{ fontSize: 13.5, fontWeight: 800 }}>Oricare drum ai alege, urmează aceiași pași simpli:</span>
        <span className="mono" style={{ fontSize: 13, color: 'var(--accent-text)', fontWeight: 700 }}>
          format → personaj → produs → voce → muzică
        </span>
        <span style={{ fontSize: 13, color: 'var(--muted)' }}>, apoi aprobi scenariul și imaginile înainte de generarea video.</span>
      </div>
    </div>
  );
}
